import { Vue, Component } from "vue-property-decorator";
import { getAuthConfig } from "../../utils/auth-helper";
import { EXTERNAL_APP_URI } from "../../common/uri/property-uri.constants";
import { LanguageHelper } from "../../utils/language-helper";

@Component({
	name: "EmailWebsite",
	template: require("./template.html")
})
export default class EmailWebsite extends Vue {
	auth = null;
	emailAppUrl = "";
	isLoading = true;

	async mounted() {
		this.isLoading = true;
		await this.authenticateAndLoadEmailApp();
	}

	get authConfig() {
		return {
			...getAuthConfig(),
			languageId: LanguageHelper.convertLanguageInt(this.$i18n.locale),
		};
	}

	async authenticateAndLoadEmailApp() {
		try {
			const authState = this.authConfig;
			if (!authState.oauth2.accessToken) {
				console.error("Authentication failed: Missing access token.");
				this.isLoading = false;
				return;
			}

			const encodedAuthState = encodeURIComponent(JSON.stringify(authState));
			this.emailAppUrl = `${EXTERNAL_APP_URI.EMAIL_APP}?auth_state=${encodedAuthState}`;

			// Delay setting isLoading = false until iframe is fully loaded
		} catch (error) {
			console.error("Error authenticating and loading email app:", error);
			this.isLoading = false;
		}
	}

	// Event handler when the iframe finishes loading
	onIframeLoad() {
		this.isLoading = false;
	}
}